import { FC } from 'react'

import styled, { css } from 'styled-components'

import CheckIcon from 'src/Assets/Svg/check-mark-green.svg?react'
import PlusIcon from 'src/Assets/Svg/plus.svg?react'
import { secondaryButtonStyles } from 'src/Components/Buttons/PrimaryButton'
import { MAX_TABLET_WIDTH, variables } from 'src/Styled/variables'

export interface SelectButtonProps {
  selected: boolean
  onClick?: () => void
  className?: string
}

const Button = styled.button<{ $selected: boolean; $loading?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  width: 40px;
  padding: 0;
  border-radius: 8px;
  flex-shrink: 0;

  ${secondaryButtonStyles}

  &:active {
    color: ${({ theme }) => theme.color.slateGrey};

    svg {
      path {
        fill: ${({ theme }) => theme.color.slateGrey};
      }
    }
  }

  ${({ $selected, theme }) =>
    $selected &&
    css`
      background: ${theme.color.lightGreen};
      border-color: ${theme.color.lightGreen};
      color: ${theme.color.darkGreen};

      &:hover {
        background: ${theme.color.lightGrey};
        border-color: ${theme.color.lightGrey};
        color: ${theme.color.darkGreen};
      }

      &:focus-visible {
        background: ${theme.color.hoverWhite};
        border-color: ${theme.color.darkGreen};
      }

      &:active {
        background: ${theme.color.hoverWhite};
        border-color: ${theme.color.lightGrey};
      }
    `}

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    width: 100%;
    padding: 0 24px;
  }
`

const Icon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: inherit;

  svg {
    width: 100%;
    height: 100%;

    path {
      fill: currentColor;
    }
  }
`

const ButtonText = styled.span`
  display: none;
  font-family: 'Segoe UI';
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize14};
  line-height: 150%;
  white-space: nowrap;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    display: inline;
  }
`

export const SelectButton: FC<SelectButtonProps> = ({
  selected,
  onClick,
  className,
}) => (
  <Button
    type='button'
    $selected={selected}
    onClick={onClick}
    className={className}
  >
    <Icon>{selected ? <CheckIcon /> : <PlusIcon />}</Icon>

    <ButtonText>{selected ? 'Selected curator' : 'Select curator'}</ButtonText>
  </Button>
)
